/**
 * INFO const symbols.
 * @constant
 * @type {Object}
 */

const INFO_ALL = 'all';

const INFO = {
    VER: 'hybridVer',
    URL_SCHEME: 'hybridUrlScheme',
    APP_NAME: 'hybridAppName',
    BUILD_TYPE: 'hybridBuildType',
    BUILD: 'hybridBuild',
    AppleID: 'AppleId',
    PUSH_PARAMS: 'hybridPushParams',
    WEB_URL: 'hybridWebUrl'
};


export {INFO, INFO_ALL};